<template>
  <div class="page">
    <div class="center-child">
     <svg xmlns="http://www.w3.org/2000/svg" width="569" height="172" viewBox="0 0 569 172">
  <text fill="#FF1515" fill-rule="evenodd" font-family="Permanent Marker" font-size="150" letter-spacing="2.269">
    <tspan x="102.124" y="126">Projects</tspan>
  </text>
</svg>

    </div>
    <div class="center-child">
      <ol>
        <ProjectRow
          v-for="(item,i) in projects"
          :key="item.id"
          :name="item.name"
          :number="i+1"
          :description="item.description"
          :topics="item.repositoryTopics.nodes"
          :uri="item.url"
        />
      </ol>
    </div>
  </div>
</template>

<script>
import ProjectRow from "../components/ProjectRow";
export default {
  name: "ProjectPage",
  components: {
    ProjectRow
  },
  data() {
    return {
      projs: []
    };
  },
  methods: {
    track() {
      this.$ga.page("/projects");
    }
  },
  computed: {
    projects: function() {
      return this.projs.filter(u => !u.isFork);
    }
  },
  beforeMount() {
    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute("content", "#FF1515");

    fetch("https://api.github.com/graphql", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "bearer aab5c4ec5b0fec8cbdb21ddcab167aa5343f2a15"
      },
      method: "POST",
      body: JSON.stringify({
        query: `{ user(login:"aniket965") { repositories(first: 20,orderBy:{direction:DESC,field:UPDATED_AT}) {
       nodes {
         id,
         name,
         description,
         isFork,
         url,
        repositoryTopics(first:5) {
          nodes{
            topic{
              id,
              name
            }}}}}}}`
      })
    }).then(d =>
      d.json().then(data => {
        this.projs = data.data.user.repositories.nodes;
      })
    );
  }
};
</script>
<style lang="scss" scoped>
ol {
  padding-inline-start: 0px;
}
@media screen and (max-width: 720px) {
  svg {
    width: 90vw;
  }
}
</style>


